import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { HeroButton } from './HeroButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function InformationSection({
  buttonText,
  buttonUrl,
  isMobile,
  isSolutionsPartnerHero,
  mobileButtonSize,
  onButtonClick,
  openCopilot,
  secondaryButtonText,
  secondaryButtonUrl,
  subtitle,
  title
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "start",
    blockSize: "100%",
    flexDirection: "column",
    gap: "800",
    justifyContent: "center",
    marginBlockEnd: isMobile ? isSolutionsPartnerHero ? '400' : '800' : '0',
    children: [/*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        marginBlockEnd: "400",
        typography: "heading-700",
        children: title
      }), /*#__PURE__*/_jsx(Text, {
        as: "p",
        typography: "body-300",
        children: subtitle
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "stretch",
      gap: "400",
      children: [/*#__PURE__*/_jsx(HeroButton, {
        buttonText: buttonText,
        buttonUrl: buttonUrl,
        onClick: onButtonClick,
        openCopilot: openCopilot,
        size: mobileButtonSize,
        use: isSolutionsPartnerHero ? 'primary' : 'secondary'
      }), isSolutionsPartnerHero && /*#__PURE__*/_jsx(HeroButton, {
        buttonText: secondaryButtonText,
        buttonUrl: secondaryButtonUrl,
        openCopilot: openCopilot,
        size: mobileButtonSize
      })]
    })]
  });
}